export default __webpack_public_path__ + "static/media/arihant1.d721d788.png";